import {useActiveVkuiLocation, useGetPanelForView, useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {DEFAULT_VIEW} from "../routing/routing";

export const useAppNavigation = () => {
    const routeNavigator = useRouteNavigator();
    const {view: activeView, modal: activeModal} = useActiveVkuiLocation();
    const activePanel = useGetPanelForView(DEFAULT_VIEW);

    return {
        routeNavigator,
        activeView,
        activeModal,
        activePanel,
    };
};